import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme) => ({
  description: {
    color: theme.colors.grey3
  },
  dropzoneSection: {
    position: 'relative',
    borderRadius: '16px',
    cursor: 'pointer',
    padding: '40px 15px',
    border: '10px dashed rgba(255, 255, 255, 0.1)',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '-8px',
      right: '-8px',
      left: '-8px',
      bottom: '-8px',
      background: '#353538',
      borderRadius: '16px',
      zIndex: 0
    }
  },
  reportItem: {
    background: 'rgba(0, 0, 0, 0.40)',
    padding: '0 16px',
    border: '1px solid rgba(255, 255, 255, 0.30)',
    borderRadius: '8px',
    margin: '16px 0'
  }
}));
